// extracted by mini-css-extract-plugin
module.exports = {"pane":"ImagePane-pane-74c0","first":"ImagePane-first-74c0","second":"ImagePane-second-74c0","active":"ImagePane-active-74c0"};